<stch-calendar-month-small-cell
  [day]="day()"
  [selected]="selected()"
  size="l"
  stchPopover
  stchPopoverPlacement="bottomLeft"
  stchPopoverTrigger="hover"
  [stchPopoverDisabled]="events().length === 0 || popupDisabled()"
  [stchPopoverDelay]="400"
  [stchPopoverContent]="moreTemplate"
  [stchPopoverShowUntil]="popoverClose"
  [stchPopoverContext]="{ day: day }"
  [stchPopoverFallbackPlacements]="['topLeft']"
/>

<ng-template #moreTemplate let-day="day">
  <stch-events-list-popup
    [events]="events()"
    [date]="displayDate()"
    [popoverClose]="popoverClose"
    (eventClicked)="eventClicked.emit($event)"
    (eventDblClicked)="eventDblClicked.emit($event)"
  />
</ng-template>
